import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { FoundQuote } from "./Quotes";
import { Vehicle } from "./Vehicles";
import { Link } from "react-router-dom";

const VehicleNumberCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  const data = props.dataItem as FoundQuote | Vehicle;

  return (
      <td {...props.tdProps}>
          <Link
              to={`/Assets/Vehicle/${data.VehicleID}`}
              target="_blank"
              style={{ color: '#007bff' }}
          >
              {data.VehicleNumber}
          </Link>
      </td>
  );
}

export default VehicleNumberCell;
